'use client';

import redEnvelop from '@i/sell-my-dirt-bike/EnvelopeSimple.svg';
import RaceCarIcon from '@i/race-car.svg';
import StarIcon from '@i/star.svg';
import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import firstGear from '@public/1st-gear.jpg';
import secondGear from '@public/2nd-gear.jpg';
import firstGearSim from '@public/1st-gear-sim.jpg';
import secondGearSim from '@public/2nd-gear-sim.jpg';

const plans = [
  {
    id: 1,
    image: firstGear,
    simImage: firstGearSim,
    title: '1st Gear',
    price: 'Free',
    cardData: [{ icon: RaceCarIcon, text: 'Listing your cars for FREE' }],
    href: '/create-listing',
  },
  {
    id: 2,
    image: secondGear,
    simImage: secondGearSim,
    title: '2nd Gear',
    price: '$39.99',
    cardData: [
      { icon: StarIcon, text: 'Featured listing' },
      {
        icon: redEnvelop,
        text: 'Included in our ‘Race Cars for Sale’ email',
      },
    ],
    href: '/create-listing',
  },
];

type Props = {
  popular?: '1st Gear' | '2nd Gear';
  selectedPlan?: number;
  setSelectedPlan?: (plan: 1 | 2) => void;
  listing?: boolean;
  variant?: 'race-car' | 'sim';
};

export const PricingSection = ({
  popular,
  listing = false,
  selectedPlan,
  setSelectedPlan,
  variant = 'race-car',
}: Props) => {
  const onPlanClick = (planId: 1 | 2) => {
    if (!setSelectedPlan) return;
    setSelectedPlan(planId);
  };

  const freeListingLabel =
    variant === 'sim' ? 'Create your listing for' : 'Listing your cars for';

  return (
    <div className="flex h-full w-full flex-col gap-12 lg:flex-row">
      {plans.map((p) => (
        <div
          key={p.id}
          onClick={() => onPlanClick(p.id as 1 | 2)}
          className={`box-border flex flex-grow flex-col overflow-hidden rounded-[16px] border bg-[#F6F6F6] lg:w-[384px]
            ${
              selectedPlan === p.id
                ? 'border-brand-secondary bg-[#f9e8e8]'
                : 'border-transparent bg-[#f6f6f6]'
            }`}
        >
          <div className="relative h-[200px] md:h-[240px]">
            <SafeImage
              src={variant === 'sim' ? p.simImage : p.image}
              alt="plan image"
              className="absolute inset-0 h-[200px] w-full md:h-[240px]"
            />
            <div className="absolute bottom-16 left-16 z-10 text-white">
              <h3 className="text-heading-h6 font-bold">{p.title}</h3>
              <span className="mb-2 text-heading-h4 font-bold">{p.price}</span>
            </div>
            {popular === p.title ? (
              <div className="text-bold absolute right-6 top-6 rounded-xl bg-brand-secondary px-4 py-1 text-label uppercase text-white">
                Popular
              </div>
            ) : null}
          </div>
          <div className="flex flex-1 flex-col justify-between gap-20 p-12 md:p-16">
            <div className="flex flex-grow flex-col items-start gap-6">
              {p.cardData.map((cardItem) => {
                const text =
                  p.title === '1st Gear' ? (
                    <p className="text-body-md font-medium text-text-muted">
                      {freeListingLabel}{' '}
                      <span className="font-bold">FREE</span>
                    </p>
                  ) : (
                    <p className="text-body-md font-medium text-text-muted">
                      {cardItem.text}
                    </p>
                  );
                return (
                  <div key={cardItem.text} className="flex items-center gap-6">
                    <SafeImage
                      src={cardItem.icon}
                      alt="header image"
                      className="mb-1 size-12"
                    />
                    {text}
                  </div>
                );
              })}
            </div>
            {listing ? null : (
              <Button
                type="secondary"
                width={'fluid'}
                text={'Get Started'}
                href={p.href}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
